import React from 'react';
import { PageLayout } from '../../components/shared/PageLayout';
import { Seo } from '../../components/shared/Seo';

const PrivacyPolicyPage: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org", "@type": "WebPage", "name": "Privacy Policy - Device Doctor", "description": "Privacy Policy for Device Doctor mobile repair services", "url": "https://devicedoctor.in/privacy-policy", "dateModified": "2025-01-01", "publisher": { "@type": "Organization", "name": "Device Doctor", "address": { "@type": "PostalAddress", "streetAddress": "Store no 1, Near Nakshatra Jewellery, Vyttila Jn", "addressLocality": "Kochi", "addressRegion": "Kerala", "postalCode": "682019", "addressCountry": "IN" } }
  };

  return (
    <PageLayout>
      <Seo
        title="Privacy Policy - Device Doctor Kochi | Mobile Repair Data Protection"
        description="Privacy Policy for Device Doctor mobile repair services in Kochi. Learn how we protect your personal information and device data during repair services. GDPR compliant privacy practices."
        keywords="privacy policy, device doctor privacy, mobile repair data protection, customer privacy kochi, repair service privacy"
        structuredData={structuredData}
      />
      
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Privacy Policy</h1>
            <p className="text-xl text-blue-100">
              Your privacy is important to us. Learn how we protect and handle your personal information.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-600 mb-6"><strong>Last Updated:</strong> January 2025</p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Information We Collect</h2>
              <p>We collect information to provide better services to all our users. This includes your name, contact details, device information (model, IMEI), and payment information.</p>
              <h2 className="text-2xl font-bold text-gray-900 my-4">2. How We Use Your Information</h2>
              <p>We use the information we collect to provide, maintain, and improve our repair services, to communicate with you about your repair status, and for billing purposes.</p>
              <h2 className="text-2xl font-bold text-gray-900 my-4">3. Information Sharing</h2>
              <p>We do not share your personal information with companies, organizations, or individuals outside of Device Doctor except with your consent or for legal reasons.</p>
              <h2 className="text-2xl font-bold text-gray-900 my-4">4. Data Security</h2>
              <p>We work hard to protect our customers from unauthorized access to or unauthorized alteration, disclosure, or destruction of information we hold.</p>
              <h2 className="text-2xl font-bold text-gray-900 my-4">5. Contact Information</h2>
              <p>If you have questions about this Privacy Policy or our data practices, please contact us at info@devicedoctor.com.</p>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default PrivacyPolicyPage;
export { PrivacyPolicyPage };